import { SITE_CALCULATOR } from '@/config/site'
import { Tariff } from '@/services/Api/generated'
import { makeAutoObservable } from 'mobx'

export const TariffNameMap: { [key in Tariff]: string } = {
  [Tariff.Self]: 'Удобный для самостоятельных',
  [Tariff.Optimal]: 'Оптимальный для уверенных',
  [Tariff.AllInclusive]: 'Все включено',
  [Tariff.WithGuarantee]: 'С гарантией',
}

export const TariffPriceMap: { [key in Tariff]: number } = {
  [Tariff.Self]: SITE_CALCULATOR.tariff.SELF,
  [Tariff.Optimal]: SITE_CALCULATOR.tariff.OPTIMAL,
  [Tariff.AllInclusive]: SITE_CALCULATOR.tariff.ALL_INCLUSIVE,
  [Tariff.WithGuarantee]: SITE_CALCULATOR.tariff.WITH_GUARANTEE,
}

export const TariffProps: { title: string; tariff: Tariff[] }[] = [
  {
    title: 'Подберем подходящие для Вас классы МКТУ',
    tariff: [
      Tariff.Self,
      Tariff.Optimal,
      Tariff.AllInclusive,
      Tariff.WithGuarantee,
    ],
  },
  {
    title: 'Проведем полную проверку обозначения по закрытым базам Роспатента',
    tariff: [Tariff.AllInclusive, Tariff.WithGuarantee],
  },
  {
    title: 'Подготовим рекомендации для повышения шансов на регистрацию',
    tariff: [Tariff.AllInclusive, Tariff.WithGuarantee],
  },
  {
    title: 'Подадим заявку на регистрацию товарного знака за 24 часа',
    tariff: [
      Tariff.Self,
      Tariff.Optimal,
      Tariff.AllInclusive,
      Tariff.WithGuarantee,
    ],
  },
  {
    title:
      'Онлайн-доступ к делопроизводству в Личном кабинете интернет-сервиса Brandside',
    tariff: [
      Tariff.Self,
      Tariff.Optimal,
      Tariff.AllInclusive,
      Tariff.WithGuarantee,
    ],
  },
  {
    title:
      'Ведем делопроизводство по заявке до завершения формальной экспертизы (дальнейшее делопроизводство в Роспатенте Вы ведете самостоятельно)',
    tariff: [Tariff.Self],
  },
  {
    title:
      'Ведем за Вас всё делопроизводство по заявке от подачи до получения свидетельства',
    tariff: [Tariff.Optimal, Tariff.AllInclusive, Tariff.WithGuarantee],
  },
  {
    title:
      'Подготовим мотивированные ответы на запросы и уведомления Роспатента',
    tariff: [Tariff.Optimal, Tariff.AllInclusive, Tariff.WithGuarantee],
  },
  {
    title: 'Запросим материалы обращений третьих лиц по заявке',
    tariff: [Tariff.Optimal, Tariff.AllInclusive, Tariff.WithGuarantee],
  },
  {
    title:
      'Вернём Вам стоимость наших услуг, если знак не пройдет регистрацию в Роспатенте, или бесплатно подадим новую заявку (если по итогам полной проверки даём заключение, что шансы на регистрацию высокие)',
    tariff: [Tariff.WithGuarantee],
  },
]

export class TariffStore {
  props = TariffProps

  get propsSelf() {
    return this.getPropsByName(Tariff.Self)
  }

  get propsOptimal() {
    return this.getPropsByName(Tariff.Optimal)
  }

  get propsAllInclusive() {
    return this.getPropsByName(Tariff.AllInclusive)
  }

  get propsWithGuarantee() {
    return this.getPropsByName(Tariff.WithGuarantee)
  }

  getPropsByName(name: Tariff) {
    return this.props
      .filter((prop) => prop.tariff.includes(name))
      .map((prop) => prop.title)
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }
}

export const tariffStore = new TariffStore()
